import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, useLocation } from "react-router-dom";
import ProductsProductsListComponent from "./components/ProductsList";
import Registration from "./components/Registration";
import Confirmation from "./components/Confirmation";
import Login from "./Login";
import MyAccount from "./components/MyAccount";
import ContactForm from "./components/ContactForm";
import Voucher from "./components/Voucher";
import { Container } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import apiService from "./services/api.service";
import i18next from "i18next";
import Modal from "react-modal";
import LoginComponent from "./Login";
import { useForm } from "react-hook-form";
import ShoppingCartComponent from "./components/ShoppingCart";
import { useSelector, useDispatch } from "react-redux";
import { addItem } from "./Redux/shoppingCartReducer";
import { setUser } from "./Redux/userReducer";
import CurrentProductComponent from "./components/CurrentProduct";
import { setChain } from "./Redux/chainReducer";
import { useTranslation } from "./hooks/useTranslation";
import { setTranslations } from "./Redux/translationsReducer";
import useCss from "./hooks/useCss";
import { Helmet } from "react-helmet";
import {
  sendFlashyEcommerceEvent,
  _ECOMMERCE_FLASHY_EVENT,
} from "./hooks/flashy-events";
import { useRouteAnnouncer } from "./hooks/useRouteAnnouncer";

function App() {
  const routes = [
    {
      path: "/product",
      name: "Products",
      Component: CurrentProductComponent,
    },
    {
      path: "/registrastion",
      name: "Registration",
      Component: Registration,
    },
    {
      path: "/confirmation",
      name: "Confirmation",
      Component: Confirmation,
    },
    { path: "/login", name: "Login", Component: Login },
    { path: "/myaccount", name: "My Account", Component: MyAccount },
    { path: "/contact", name: "Contact Form", Component: ContactForm },
    { path: "/gv", name: "Get Voucher", Component: Voucher },
    {
      path: "/",
      name: "Home",
      Component: ProductsProductsListComponent,
    },
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
  });

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const chainId = urlParams.get("chainid") || 0;
  const [thisAccountCustomer, setThisAccountCustomer] = useState(null);
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false);
  const [modalShoppingCartIsOpen, setModalShoppingCartIsOpen] = useState(false);
  const itemsFromRedux = useSelector((state) => state.cart.items);
  const productsFromSession = window.sessionStorage.getItem("products");
  const chain = useSelector((state) => state.chain);
  const loggedUser = useSelector((state) => state.user.user);
  const items = productsFromSession
    ? JSON.parse(productsFromSession)
    : itemsFromRedux;
  const dispatch = useDispatch();
  const companyUser = useSelector((state) => state.company.companyUser);
  const settingsCategoryId = process.env.REACT_APP_TRANSLATIONS_CATEGORY;
  const cssString = useCss();
  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };
  const getTranslations = () => {
    apiService.getTranslations(settingsCategoryId).then((response) => {
      if (response.data.data && !response.data.errors) {
        const fetchedTranslations = {};

        response.data.data.forEach((beKey) => {
          const key = beKey["settingsKey"];

          let translationValue = beKey.values?.find(
            (value) =>
              value.languageIsoCode === lang && value.chainId == chainId
          )?.value;

          if (!translationValue) {
            translationValue = beKey.values?.find(
              (value) => value.languageIsoCode === lang && value.chainId == 0
            )?.value;
          }
          fetchedTranslations[key] = translationValue;
        });
        dispatch(setTranslations(fetchedTranslations));
      }
    });
  };

  useEffect(() => {
    if (chainId && lang) {
      getTranslations();
    }
  }, [chainId, lang]);
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = cssString;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, [cssString]);
  useEffect(() => {
    if (chainId) {
      apiService.getChains(chainId).then((response) => {
        if (!response.errors && response.data && response.data.data) {
          sessionStorage.setItem(
            "chain",
            JSON.stringify(response.data.data[0])
          );
          dispatch(setChain(response.data.data[0]));
        }
      });
    }
  }, [chainId]);

  useEffect(() => {
    if (!Object.keys(itemsFromRedux).length && Object.keys(items).length) {
      for (let i in items) {
        for (let k = 0; k < items[i].qty; k++) {
          dispatch(addItem({ selectedProduct: items[i].selectedProduct }));
        }
      }
    }
  }, []);

  useEffect(() => {
    setLang(urlParams.get("lang") || "eng");
    if (loggedUser) {
      findCustomer(loggedUser.email, loggedUser.id, true);
    } else {
      setThisAccountCustomer(null);
    }

    if (window.parent !== window.self) {
      window.parent.postMessage({ iframe_loaded: true }, "*");
      console.info("dispatch event to loaded event!");
    }
  }, [loggedUser]);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);

  const findCustomer = (email, customerId, isGetOrders) => {
    apiService.getCustomer(email).then(
      (response) => {
        if (response.data.data && response.data.data.length > 0) {
          var custId =
            response.data.data[response.data.data.length - 1].customerId;
          if (custId !== customerId) {
          } else {
            setThisAccountCustomer(
              response.data.data[response.data.data.length - 1]
            );

            if (
              window.location.href.includes("contact") &&
              !window.location.href.includes("cxl=1")
            ) {
              goToMyAccount();
            }
          }
        }
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  };
  const logout = () => {
    dispatch(setUser(null));
    setThisAccountCustomer(null);
    window.location.href = `/?chainid=${chainId}&lang=${
      urlParams.get("lang") || "eng"
    }`;
  };

  const login = () => {
    setModalTermsIsOpen(true);
  };

  const openCart = () => {
    setModalShoppingCartIsOpen(true);
  };

  const goToMyAccount = () => {
    window.location.href = `/myaccount?chainid=${chainId}&lang=${
      urlParams.get("lang") || "eng"
    }`;
  };

  const getItemsInCartCount = () => {
    let count = 0;
    if (items) {
      for (let key of Object.keys(items)) {
        count += items[key].qty;
      }
    }
    return count;
  };

  return (
    <Router>
      <>
        <RouteAnnouncer
          onRouteChange={() => {
            setModalTermsIsOpen(false);
            setModalShoppingCartIsOpen(false);
          }}
        />
        <Container className="container">
          {routes.map(({ path, Component, props = {} }) => (
            <Route key={path} exact path={path}>
              {({ match }) => (
                <CSSTransition
                  in={match != null}
                  timeout={300}
                  classNames="opacity-node"
                  unmountOnExit
                >
                  <div className="page" id="main-page">
                    {!companyUser && (
                      <div className="my-account-wrap row">
                        {thisAccountCustomer &&
                        !window.location.href.includes("myaccount") &&
                        !window.location.href.includes("gv") ? (
                          <div className="col-10">
                            <span className="greeting_txt"></span>
                            {t("Hello") +
                              " " +
                              thisAccountCustomer.customerFirstName +
                              " " +
                              thisAccountCustomer.customerLastName +
                              ","}{" "}
                            <button
                              className="logout btn-link account-btn"
                              onClick={(e) => goToMyAccount()}
                            >
                              {t("GoToMyAccount")}
                            </button>{" "}
                            ,{" "}
                            <button className="logout btn-link account-btn" onClick={(e) => logout()}>
                              {t("Logout")}
                            </button>
                          </div>
                        ) : !window.location.href.includes("login") &&
                          !window.location.href.includes("myaccount") &&
                          !window.location.href.includes("gv") ? (
                          <div className="col-10 not-logged-in">
                            <span className="greeting_txt"></span>
                            {t("Hello") + " " + t("Guest") + " ,"}{" "}
                            <span className="logout" onClick={(e) => login()}>
                              {t("LoginBtn")}
                            </span>
                          </div>
                        ) : null}
                        <div
                          className="top-cart-wrap col-2 hidden"
                          onClick={(e) => openCart()}
                        >
                          <div className="ttl-items">
                            {" "}
                            {getItemsInCartCount()}
                          </div>
                          <div className="cart-ttl">{t("ShopCart")}</div>
                        </div>
                      </div>
                    )}
                    <Component {...props} />
                    {t("IsLogoVisible") !== "false" &&
                      //dont show logo in voucher page
                      !window.location.href.includes("/gv") && (
                        <div className="simplexLogo"></div>
                      )}
                    <Modal
                      isOpen={modalTermsIsOpen}
                      contentLabel=""
                      className="login-modal"
                    >
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          onClick={(e) => setModalTermsIsOpen(false)}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <LoginComponent popupLogin="true"></LoginComponent>
                      </div>
                    </Modal>
                    <Modal
                      isOpen={modalShoppingCartIsOpen}
                      contentLabel=""
                      className="login-modal"
                    >
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          onClick={(e) => setModalShoppingCartIsOpen(false)}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ShoppingCartComponent
                          register={register}
                          errors={errors}
                          handleSubmit={handleSubmit}
                          topCart={true}
                        ></ShoppingCartComponent>
                      </div>
                    </Modal>
                  </div>
                </CSSTransition>
              )}
            </Route>
          ))}
        </Container>
      </>
    </Router>
  );
}

export default App;


/**
 * Announces route changes to screen readers by moving focus to a visually
 * hidden <div> that stays mounted for the lifetime of the app. On each
 * navigation, useRouteAnnouncer() sets its text content to the new page
 * title and focuses it, so screen readers announce that title directly
 * (no separate aria-live region — focusing an element with short text
 * announces just that text, unlike focusing the whole page content).
 *
 * Also closes any open modal on route change, since modal open/closed
 * state isn't otherwise tied to the route, and resets document.title to
 * the app's original default before each page's own effects run, so a
 * route that never sets its own title (e.g. the products list) doesn't
 * keep showing whatever the previous page's title was.
 *
 * Each page component should set document.title for the announcement
 * e.g. useEffect(() => { document.title = 'Title text'; }, [translations])
 *
 * Place this once, near the top of your Router tree.
 */
function RouteAnnouncer({ onRouteChange }) {
  const location = useLocation();
  const defaultTitleRef = useRef(document.title);
  useRouteAnnouncer();

  useEffect(() => {
    document.title = defaultTitleRef.current;
    onRouteChange?.();
  }, [location.pathname]);

  return <>

        {/* Visually hidden, always in the DOM */}
        <div
          id="route-announcer"
          tabIndex={-1}
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            whiteSpace: 'nowrap',
          }}
        />

  </>;
}








